import { Injectable } from '@angular/core';
import { TimezoneResources } from "@core/resources/timezone.resources";
import { TimeZoneState } from '@core/states/time-zone.state';
import { AttachYCState, BaseYCService } from '@yourcause/common/state';

@AttachYCState(TimeZoneState)
@Injectable({ providedIn: 'root'})
export class TimeZoneService extends BaseYCService<TimeZoneState> {

  constructor (
    private timezoneResources: TimezoneResources
  ) {
    super();
  }

  get timeZones () {
    return this.get('timeZones');
  }

  async setTimeZones () {
    if (!this.timeZones) {
      const timezones = await this.timezoneResources.getTimezones();
      this.set('timeZones', timezones);
    }
  }

  getTimeZones () {
    return this.get('timeZones');
  }

  returnTimeZoneFromID (timezoneId: string) {
    return this.timeZones.find((tz) => {
      return (tz.id === timezoneId);
    }) || {
      id: 'UTC',
      displayName: 'UTC',
      offset: 0
    };
  }

  getTimezoneOptions () {
    return this.timeZones.map((zone) => {
      return {
        label: zone.displayName,
        value: zone.id
      };
    });
  }
}
